import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-align-center",
  "use": "icon-align-center-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-align-center\">\r\n<path d=\"M480 64h64v896h-64z\" p-id=\"7211\" /><path d=\"M256 192h512v256H256z\" p-id=\"7212\" /><path d=\"M128 576h768v256H128z\" p-id=\"7213\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol